import ApplicationBase from "TemplatesCommonLib/baseClasses/ApplicationBase";

import MainApp from "./Widget";

export default (applicationConfigJSON: string, boilerplateConfigJSON: string, i18n: any) => {
    const config = JSON.parse(applicationConfigJSON);
    const settings = JSON.parse(boilerplateConfigJSON);

    const boilerplate = new ApplicationBase({ config, settings });
    const MainComponent = new MainApp({ boilerplate, i18n });
    MainComponent.container = "viewDiv";
    
    // Set locale & direction
    document.documentElement.lang = boilerplate.locale;
    var dirNode = document.getElementsByTagName("html")[0];
    dirNode.setAttribute("dir", boilerplate.direction);
};



// WEBPACK FOOTER //
// ./src/mainApp/index.ts